import axios from 'axios';
import { getFamilyMembersAction } from './GetFamilyMembersSlice';

const getFamilyMembers = (token) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/family/members`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(url, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(getFamilyMembersAction.getFamilyMembersSuccess(result.data));
    } catch (e) {
      dispatch(getFamilyMembersAction.getFamilyMembersFailure(e.response?.data ?? e.message));
    }
  };
};

export default getFamilyMembers;